import styled from "styled-components";
import { IAutoplayButton } from "..";
import * as h from "../../_themes/helpers";
import { BaseButton } from "../../BaseButton";
import { IBaseButton } from "../../BaseButton";

export const Wrapper = styled<IBaseButton & IAutoplayButton>(BaseButton)`
  color: ${h.getColor("autoplayButtonIcon", "autoplayButton.icon")};

  &:active {
    color: ${h.getPressedColor("autoplayButtonIcon", "autoplayButton.icon")};
  }

  &[disabled] {
    color: ${h.getDisabledColor("autoplayButtonIcon", "autoplayButton.icon")};
  }

  svg > * {
    pointer-events: visible;
  }

  p {
    margin: 0;
    font-size: ${(props: IAutoplayButton) =>
      props.autoplayRoundsLeft > 999 ? "0.6em" : "0.8em"};
    margin-left: ${(props: IAutoplayButton) =>
      props.autoplayRunning ? "0" : "0.15em"};
    font-weight: 700;

    position: absolute;
    left: 50%;
    top: 50%;
    width: 50%;
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translate(-50%, -50%);
    color: ${h.getColor("autoplayButtonText", "autoplayButton.text")};
    z-index: 1;

    &:hover {
      color: ${h.getHoverColor("autoplayButtonText", "autoplayButton.text")};
    }

    &:active {
      color: ${h.getPressedColor("autoplayButtonText", "autoplayButton.text")};
    }

    &[disabled] {
      color: ${h.getDisabledColor("autoplayButtonText", "autoplayButton.text")};
    }
  }
`;
